import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from 'react';
import ReactDOM from 'react-dom';
// import * as _redux from "./redux";
import App from './App'; 
import "@fortawesome/fontawesome-free/css/all.min.css";
import "react-datepicker/dist/react-datepicker.css";
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history'
import { Router } from 'react-router-dom'
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/app.scss'
import store from './redux/store/store'
import instalarCompresionGlobal from './functions/compresionGlobal'

// Toda foto pesada que se suba por axios se comprime antes de enviarse (ver functions/compresionGlobal.js)
instalarCompresionGlobal()

// const { PUBLIC_URL } = process.env;
const history = createBrowserHistory();

// Cache de emotion dedicada para MUI 5 (clave "mui").
// Aísla los <style data-emotion> de MUI (emotion v11) de la emotion v10 legacy
// que arrastran react-select / react-beautiful-dnd (@emotion/core 10). Si comparten
// la clave por defecto "css", MUI puede inyectar en el <style> equivocado al abrir
// un modal y el override `sx` de los botones pierde ante la clase base .MuiButton-*.
const muiCache = createCache({ key: 'mui' });

ReactDOM.render(
    <CacheProvider value={muiCache}>
        <Provider store={store}>
            <Router history={history}>
                <App history={history}/>
            </Router>
        </Provider>
    </CacheProvider>  ,	document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();